import * as yup from "yup";
const nameRegExp = /^[A-Za-z]+$/; // Regular expression to allow only letters
const phoneRegExp = /^(01[0,1,2,5])\d{8}$/;
const nameSpaceRegExp = /^[a-zA-Z ]+$/; // Regular expression to allow only letters and spaces
const arabicEnglishRegExp = /^[a-zA-Z\u0600-\u06FF ]*$/;
const arabicEnglishNumbersRegExp = /^[a-zA-Z\u0600-\u06FF0-9 ]*$/;
export const ArSchema = yup.object().shape({

  company_name: yup
    .string()
    .min(3, "يجب ألا يقل عن 3 حروف")
    .trim()
    .matches(arabicEnglishNumbersRegExp, "غير صحيح")
    .required("إجباري"),
  specialist_name: yup
    .string()
    .min(3, "يجب ألا يقل عن 3 حروف")
    .trim()
    .matches(arabicEnglishRegExp, "غير صحيح")
    .required("إجباري"),
  phoneNumber: yup
    .string()
    .matches(
      phoneRegExp,
      "رقم الهاتف يجب أن يبدأ بـ (010/011/012/015) وعلى الاقل 11 رقم"
    )
    .required("إجباري"),
  email: yup.string().email("غير صحيح").required("إجباري"),
  categories: yup.string().required("إجباري"),
  url: yup.string().trim().min(3, "يجب ألا يقل عن 3 حروف").required("إجباري"),
  address: yup
    .string()
    .trim()
    .min(3, "يجب ألا يقل عن 3 حروف")
    .required("إجباري"),
  governorate: yup.string().min(3, "يجب ألا يقل عن 3 حروف").required("إجباري"),
  branch_number: yup.string().trim().required("إجباري"),
  POS: yup.string().required("إجباري"),
  eCommerce: yup.string().oneOf(["yes", "no"]).required("إجباري"),
  commercialTax: yup.string().oneOf(["yes", "no"]).required("إجباري"),
});
